function Heelflip() {
  return (
    <div className="dice-face face--heelflip">
      <span>HEEL</span>
      <span>FLIP</span>
    </div>
  );
}

export default Heelflip;
